module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hnGWh"))).then(() => module.bundle.root('jnagv'));